module.exports = __webpack_public_path__ + "media/bootstrap-icons/flag-1cf0221b.svg";